import { ApiService } from '../../services/api_service';
import breadcrumbStyle from '../start/BreadcrumbNavigation.less';
import { checkFunktionFuerBereich } from '../../main/functions/checkFunktionFuerBereich';
import { ContextService } from '../../services/context_service';
import { Dateiablage } from '../dateiablage/Dateiablage';
import { getDefaultHelpIcon, getDefaultHelpIconDatei } from '../../helpers/getDefaultHelpIcon';
import { hasEffizienznetzwerk } from '../helper';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { StructureService } from '../../services/structure_service';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';
import { ZusatzToolsProjektion } from './ZusatzToolsProjektion';
import { ZusatztoolsCO2 } from './ZusatzToolsCO2';
import { ZusatztoolsEinzelmassnahmen } from './ZusatztoolsEinzelmassnahmen';
import { ZusatztoolsEntwicklungsfahrplan } from './ZusatztoolsEntwicklungsfahrplan';
import { ZusatztoolsInfosBerater } from './ZusatztoolsInfosBerater';
import { ZusatztoolsLastgaenge } from './ZusatztoolsLastgaenge';
import { ZusatztoolsPv } from './ZusatztoolsPv';
import { ZusatztoolsReportExport } from './ZusatzToolsReportExport';
import { ZusatztoolsToolExcelImport } from './ZusatztoolsToolExcelImport';
import { ZusatztoolsZaehler } from './ZusatztoolsZaehler';
import { ZusatztoolsZertifizierung } from './ZusatzToolsZertifizierung';
import { ZusatzToolsModulEED } from './ZusatzToolsModulEED';

interface ZusatztoolsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    reloadData: () => void;
    routing: any;
    standortSelected: any;
}

interface ZusatztoolsState {
    tabIndex: number;
}

export class Zusatztools extends React.Component<ZusatztoolsProps, ZusatztoolsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxZusatztools') || 0
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(StructureService) private structureService: StructureService;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_ZUSATZTOOLS;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_ZUSATZTOOLS;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxZusatztools', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const bereich_key: string = (((this.props.data || {})[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig;
        const isAdmin: boolean = this.apiService.isAdmin() || this.apiService.getUsername() === 'yang.wang@wips-home.de'; // Zum Testen
        const disabledEffizienznetzwerk: boolean = !hasEffizienznetzwerk(this.props.data);
        const disabledEnergiekostenProjektion: boolean = false;
        const disabledInfosBerater: boolean = !this.apiService.isAdmin() && !this.apiService.isBerater();
        const disabledLastgaenge: boolean = !IDs.FLAG_ENABLE_LASTGANG;
        const disabledZusatztoolsToolExcelImport: boolean = !checkFunktionFuerBereich('Zusatztools_Tab_Import_Excel', bereich_key);
        const disabledZusatztoolsZertifizierung: boolean = !checkFunktionFuerBereich('Zusatztools_Tab_Zertifizierung', bereich_key);
        const tabRoutings: any[] = [
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_KOSTEN_PROJEKTION },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_DOKUMENTENABLAGE },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_EFFIZIENZNETZWERK },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_ECOMAPPING },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_ENTWICKLUNGSPLAN },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_TOOL_EXCEL_IMPORT },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_LASTGAENGE },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_CO2_TOOL },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_MONITORING_EINZELMASSNAHMEN },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_PV },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_ZAEHLER },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_ZERTIFIZIERUNG },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_INFOS_BERATER },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_REPORT_EXPORT },
            { path: RoutingIDs.ROUTE_ZUSATZTOOLS_EED }
        ];
        
        return (
            <Tabs
                className='tabs-zusatztools'
                style={{
                    // flex: 1, flexDirection: 'column', display: 'flex', minHeight: 0,
                    overflow: 'auto'
                }}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set('tabIdxZusatztools', this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab disabled={disabledEnergiekostenProjektion}>{i18n('Energiekosten-Projektion', 'tab')}</Tab>
                    <Tab>{i18n('Dokumentenablage', 'tab')}</Tab>
                    <Tab disabled={disabledEffizienznetzwerk}>{i18n('Effizienznetzwerk', 'tab')}</Tab>
                    <Tab disabled>{i18n('Ecomapping', 'tab')}</Tab>
                    <Tab>{i18n('Entwicklungsfahrplan', 'tab')}</Tab>
                    <Tab disabled={disabledZusatztoolsToolExcelImport}>{i18n('Import: Excel E-Tool', 'tab')}</Tab>
                    <Tab disabled={disabledLastgaenge}>{i18n('Lastgänge', 'tab')}</Tab>
                    <Tab>{i18n('Mehrkosten CO₂ Bepreisung', 'tab')}</Tab>
                    <Tab disabled>{i18n('Monitoring Einzelmaßnahmen', 'tab')}</Tab>
                    <Tab>{i18n('PV Berechnungs-Tool', 'tab')}</Tab>
                    <Tab disabled>{i18n('Zähler', 'tab')}</Tab>
                    <Tab disabled={disabledZusatztoolsZertifizierung}>{i18n('Zertifizierung', 'tab')}</Tab>
                    <Tab disabled={disabledInfosBerater}>{i18n('Infos für Berater:innen', 'tab')}</Tab>
                    <Tab>{i18n('Report / Export', 'tab')}</Tab>
                    <Tab>{i18n('EED', 'tab')}</Tab>
                </TabList>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 0 ? 1 : 0 }}
                >
                    {!disabledEnergiekostenProjektion && <>
                        {getDefaultHelpIcon('pageKostenProjektion', 'Hilfe zu Energiekosten-Projektion', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <ZusatzToolsProjektion
                            data={this.props.data}
                        />
                    </>}
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 1 ? 1 : 0
                    }}
                >
                    <Dateiablage
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        tabsClassName='tabs-zusatztools'
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 1 ? 2 : 0
                    }}
                >
                    {!disabledEffizienznetzwerk && this.props.routing?.path &&
                    <>
                        {this.props.routing.path.tabEffizienznetzwerk === 0 ? <Dateiablage
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            tabsClassName='tabs-effizienznetzwerk'
                        /> : 
                        <ZusatztoolsEinzelmassnahmen />}
                    </>
                    }
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 3 ? 1 : 0 }}
                >
                    {getDefaultHelpIcon('pageEcomapping', 'Hilfe zum Eco-Mapping', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <p>Ecomapping</p>
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 4 ? 1 : 0 }}
                >
                    {getDefaultHelpIconDatei('entwicklungsfahrplan_ibef', 'Hilfe zum Entwicklungsfahrplan', this.props.data, breadcrumbStyle.breadcrumb_infoicon)}
                    <ZusatztoolsEntwicklungsfahrplan
                        data={this.props.data}
                    />
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 5 ? 1 : 0 }}
                >
                    {!disabledZusatztoolsToolExcelImport
                        ? <div>
                            {getDefaultHelpIcon('pageExcelImport', 'Hilfe zum Excel-Import', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                            <ZusatztoolsToolExcelImport
                                data={this.props.data}
                                onRoutingChange={this.props.onRoutingChange}
                                standortSelected={this.props.standortSelected}
                            />
                        </div>
                        : <div>Dieser Bereich steht für den Kulturbereich nicht zur Verfügung.</div>
                    }
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 6 ? 1 : 0 }}
                >
                    {!disabledLastgaenge && <>
                        {getDefaultHelpIcon('pageLastgänge', 'Hilfe zu den Lastgängen', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <ZusatztoolsLastgaenge
                            data={this.props.data}
                            standortSelected={this.props.standortSelected}
                        />
                    </>}
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 7 ? 1 : 0 }}
                >
                    {getDefaultHelpIcon('pageCO2', 'Hilfe zu Mehrkosten CO2-Bepreisung', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <ZusatztoolsCO2
                        isEtool={true}
                        onRoutingChange={this.props.onRoutingChange}
                        data={this.props.data}
                    />
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 8 ? 1 : 0 }}
                >
                    <ZusatztoolsEinzelmassnahmen />
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 9 ? 1 : 0 }}
                >
                    {getDefaultHelpIcon('pagePV', 'Hilfe zum PV Berechnungs-Tool ', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <ZusatztoolsPv
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                    />
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 10 ? 1 : 0 }}
                >
                    {getDefaultHelpIcon('pageZaehler', 'Hilfe zu Zählern', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <ZusatztoolsZaehler
                        standortSelected={this.props.standortSelected}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 11 ? 1 : 0
                    }}
                >
                    {!disabledZusatztoolsZertifizierung &&
                        <ZusatztoolsZertifizierung
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                        />
                    }
                </TabPanel>
                <TabPanel
                    style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 12 ? 1 : 0 }}
                >
                    {!disabledInfosBerater &&
                        <ZusatztoolsInfosBerater
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 13 ? 1 : 0
                    }}
                >
                    <ZusatztoolsReportExport
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 14 ? 1 : 0
                    }}
                >
                    {getDefaultHelpIcon('pageZusatzToolsModulEED', 'Hilfe zu EED', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <ZusatzToolsModulEED
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                    />
                </TabPanel>
            </Tabs>
        );
    }
}
